/* eslint-disable no-console */
import { useState, useEffect, FC, ReactElement } from 'react'
import { getGuestTask, getAuthorizeTask } from 'src/services/api.service'
import { useAuth } from 'src/contexts/auth.context'
import { Viewer } from 'src/components/builder/viewer'
import { cookies } from 'src/services/storage'
import { toJSON } from 'src/tools'
import { TaskItemResponse } from 'src/services/dto'

interface FrontPageProps {
  levelId: string
  sessionId: string
}

export const FrontPage: FC<FrontPageProps> = ({
  levelId,
  sessionId,
}): ReactElement => {
  const token = cookies.getItem('token')

  const { user } = useAuth()

  const [loading, setLoading] = useState(false)
  const [practice, setPractice] = useState<TaskItemResponse>()
  const [error, setError] = useState(false)
  const [defaultQuestionTitle, setDefaultQuestionTitle] = useState<string>('')

  useEffect(() => {
    const fetchAsync = async () => {
      try {
        setLoading(true)
        setError(false)
        const response = token
          ? await getAuthorizeTask(levelId)
          : await getGuestTask(levelId, sessionId)

        const rest = {
          page_layout: '',
          sub_type: '',
        }
        try {
          const [level] = response.data?.item.levels

          const params = toJSON(level.problem_types_params)

          if (level.page_layout) {
            rest.page_layout = level.page_layout
          }
          if (level.view_type) {
            rest.sub_type = level.view_type
          }
          if (level.default_question_title) {
            setDefaultQuestionTitle(level.default_question_title)
          }
        } catch (err) {
          console.log('page_layout parse', err)
        }

        setPractice({
          ...response.data?.item,
          ...rest,
        })
        setLoading(false)
      } catch (errorMsg) {
        setError(true)
        setLoading(false)
      }
    }
    fetchAsync()
  }, [])

  const handleFinishClick = () => {
    window.history.back()
  }

  if (loading) {
    return <div />
    // return <div className='task-not-found'>
    //   <span>Loading...</span>
    // </div>
  }

  if (error) {
    return (
      <div className="row unlock-container">
        <div className="col-lg-3" />
        <div className="col-lg-6">
          <div className="popap-img">
            <img src="/account/img/popap/img-5.svg" alt="" />
          </div>
          <h3 className="popap-title">It’s time to unlock!</h3>
          <div className="popap-info">
            <p>
              You have run out of free practices preview. Please add a payment
              method to your account to continue practithink. Full membership
              get you:
            </p>
            <ul>
              <li>Unlimited practices</li>
              <li>Personalized, results-based recommendations</li>
              <li>Full access to Practithink printables and learning resources</li>
              <li>Report cards and progress tracking for skills studied</li>
            </ul>
          </div>
          <br />
          <a
            rel="noreferrer"
            href="https://account.practithink.com/register"
            className="primary-btn"
          >
            Join now{' '}
          </a>
        </div>
        <div className="col-lg-3" />
      </div>
    )
  }

  if (!practice) {
    return (
      <div className="task-not-found">
        <span>Task not found. Please select another type</span>
      </div>
    )
  }

  return (
    <div className="practice-viewer">
      <Viewer
        defaultQuestionTitle={defaultQuestionTitle}
        practice={practice}
        mode={user?.id ? 'authorize' : 'anonymous'}
        sessionId={sessionId}
        onFinishClick={handleFinishClick}
      />
    </div>
  )
}
